import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useOffer} from '../hooks/useOffer.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';


export const EditPage = () => {

    const {id: offerId} = useParams();

    if (typeof offerId === 'undefined') {
        throw new Error('offerId is required parameter');
    }

    const {
        record: offer,
        updateRecord,
        loading,
    } = useOffer(offerId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    if (loading || !offer) {
        return <PlatformLoader message='Loading offer...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={offer.name ? offer.name : offer.id}
            pageNavigation={<EditPageNavigation component={offer}/>}
            tools={tools}
        >

            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={offer}
                    />
                </Stack>
                :
                <RecordForm
                    record={offer}
                    handleSubmit={updateRecord}
                />}

        </FormPageLayout>
    );
};
